import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ed64004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-question-sign" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "belt-tooltip-title" }, " Belt Calculations ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Your "),
    /*#__PURE__*/_createElementVNode("em", null, "annual belt"),
    /*#__PURE__*/_createTextVNode(" is calculated from your best full 12 month period.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Your "),
    /*#__PURE__*/_createElementVNode("em", null, "running belt"),
    /*#__PURE__*/_createTextVNode(" is calculated from the best of either the previous 3 months or this month and the previous 2 months.")
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "belt-container" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "avatar"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "thought-belt-status" }
const _hoisted_10 = { class: "belt-picker" }
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTipComponent = _resolveComponent("ToolTipComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createTextVNode("Belt Projector "),
        _createVNode(_component_ToolTipComponent, { class: "x-to-y-tooltip" }, {
          trigger: _withCtx(() => [
            _hoisted_2
          ]),
          content: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.activeBelt !== null)
            ? (_openBlock(), _createElementBlock("div", {
                key: _ctx.activeBelt.Type,
                class: "belt"
              }, [
                _createElementVNode("p", { innerHTML: _ctx.nextBeltDisplay }, null, 8 /* PROPS */, _hoisted_6),
                (_ctx.activeBelt.IsAboveCurrentBelt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("img", { src: _ctx.userAvatarImageURL }, null, 8 /* PROPS */, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["thought-belt-annual thought-belt-colour", [_ctx.beltClass(_ctx.BeltType.Year)]])
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(["thought-belt-running-rate thought-belt-colour", [_ctx.beltClass(_ctx.BeltType.Quarter)]])
                        }, null, 2 /* CLASS */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.belts, (belt) => {
          return (_openBlock(), _createElementBlock("button", {
            key: belt.Type,
            title: _ctx.BeltType[belt.Type],
            class: _normalizeClass({
						'active': belt.IsActive,
					}),
            onClick: _withModifiers(($event: any) => (_ctx.setBeltActive(belt)), ["prevent"])
          }, _hoisted_13, 10 /* CLASS, PROPS */, _hoisted_11))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}